import { useEffect } from 'react'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import { API_URL } from '../lib/api'

export default function Referral() {
  const { code } = useParams<{ code: string }>()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (!code) {
      navigate('/free', { replace: true })
      return
    }

    // Store referral code
    sessionStorage.setItem('ref_code', code)

    // Parse UTM params from URL
    const params = new URLSearchParams(location.search)
    const utmSource = params.get('utm_source')
    const utmMedium = params.get('utm_medium')
    const utmCampaign = params.get('utm_campaign')
    const utmContent = params.get('utm_content')

    if (utmSource) sessionStorage.setItem('utm_source', utmSource)
    if (utmMedium) sessionStorage.setItem('utm_medium', utmMedium)
    if (utmCampaign) sessionStorage.setItem('utm_campaign', utmCampaign)
    if (utmContent) sessionStorage.setItem('utm_content', utmContent)

    // Get or create visitor ID
    let visitorId = localStorage.getItem('fc_visitor_id')
    if (!visitorId) {
      visitorId = crypto.randomUUID()
      localStorage.setItem('fc_visitor_id', visitorId)
    }

    // Track the referral
    fetch(`${API_URL}/api/funnel/utm`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        page: `/ref/${code}`,
        utm_source: utmSource || 'referral',
        utm_medium: utmMedium || 'referral',
        utm_campaign: utmCampaign || code,
        utm_content: utmContent,
        referrer: document.referrer || null,
        visitor_id: visitorId,
        ref_code: code,
      }),
    })
      .catch(() => {})
      .finally(() => {
        navigate('/free', { replace: true })
      })
  }, [code, navigate, location.search])

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#faf9f7',
    }}>
      <p style={{ color: '#999', fontSize: '0.95rem' }}>Redirecting...</p>
    </div>
  )
}
